import{getDefaultExportFromCjs as o}from"./_commonjsHelpers.js";import{__require as r}from"../node_modules/dayjs/plugin/advancedFormat.js";var e=o(r());export{e as default};
